"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTemplateFormSchema = void 0;

var yup = _interopRequireWildcard(require("yup"));

var createTemplateFormSchema = function createTemplateFormSchema(_ref) {
  var _ref$messageLimitMax = _ref.messageLimitMax,
      messageLimitMax = _ref$messageLimitMax === void 0 ? 1000 : _ref$messageLimitMax;
  return yup.object().shape({
    name: yup.string().label('Template name').trim().required().min(3).max(255),
    subject: yup.string().label('Message subject').trim().required().min(3).max(255),
    message: yup.string().label('Message').trim().required().min(25).max(messageLimitMax)
  });
};

exports.createTemplateFormSchema = createTemplateFormSchema;